import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const UrlParamsCapture = () => {
  const location = useLocation();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const companyWebsite = searchParams.get("company_website");
    const companyName = searchParams.get("company_name");
    const selectedPlan = searchParams.get("selected_plan");

    if (companyWebsite || companyName || selectedPlan) {
      const landingRef = {
        ...(companyWebsite && { company_website: companyWebsite }),
        ...(companyName && { company_name: companyName }),
        ...(selectedPlan && { selected_plan: selectedPlan }),
      };
      localStorage.setItem("landingRef", JSON.stringify(landingRef));
    }
  }, [location.search]);

  return null;
};
